// extracted by mini-css-extract-plugin
export var standaloneTable = "_1h-0";
export var standaloneTableWithBodyFill = "_1h-1";
export var withExtraHeader = "_1h-2";